/* ═══════════════════════════════════════════
   CDS Bundle Picker — Standalone JS
   Adapted for Sealina (Flow / Eight Themes)
   ═══════════════════════════════════════════ */
(function(){
  'use strict';

  /* ── Helpers ── */
  function escapeHtml(str){
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* Money formatting — read shop.money_format from wetheme-global */
  var MF = '';
  try {
    var g = document.getElementById('wetheme-global');
    if(g) MF = JSON.parse(g.textContent).moneyFormat || '';
  } catch(e){ MF = '{{amount}} EUR'; }

  /* Renvoie true si le montant (en centimes) doit etre masque : produit offert / prix a 0 */
  function isFreePrice(c){
    return c == null || Number(c) <= 0;
  }

  function fmt(c){
    if(c == null) return '';
    var a = (c / 100).toFixed(2);
    var ac = a.replace('.', ',');
    var an = Math.round(c / 100).toString();
    return MF
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, ac.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, an.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, an)
      .replace(/\{\{\s*amount\s*\}\}/g, a);
  }

  /* Color detection */
  var COLOR_MAP = {
    'noir':'#000','black':'#000','blanc':'#fff','white':'#fff',
    'rouge':'#c0392b','red':'#c0392b','bleu':'#2980b9','blue':'#2980b9',
    'vert':'#27ae60','green':'#27ae60','jaune':'#f1c40f','yellow':'#f1c40f',
    'rose':'#e91e8b','pink':'#e91e8b','orange':'#e67e22',
    'violet':'#8e44ad','purple':'#8e44ad','gris':'#95a5a6','grey':'#95a5a6','gray':'#95a5a6',
    'marron':'#6d4c41','brown':'#6d4c41','beige':'#d4c5a9',
    'creme':'#f5f0e1','cream':'#f5f0e1','bordeaux':'#722f37','burgundy':'#722f37',
    'navy':'#1a237e','marine':'#1a237e','turquoise':'#1abc9c',
    'corail':'#e74c3c','coral':'#e74c3c','or':'#d4a843','gold':'#d4a843',
    'argent':'#c0c0c0','silver':'#c0c0c0','kaki':'#6b6b3d','khaki':'#6b6b3d',
    'camel':'#c19a6b','ivoire':'#fffff0','ivory':'#fffff0',
    'taupe':'#483c32','sable':'#c2b280','sand':'#c2b280'
  };
  var COLOR_NAMES = ['color','colour','couleur','farbe','colore','color/colour'];
  function isColorOpt(n){ return COLOR_NAMES.indexOf(n.toLowerCase().trim()) >= 0; }
  function colorHex(n){ return COLOR_MAP[n.toLowerCase().trim()] || null; }
  function sizedImg(src, sz){
    if(!src) return '';
    return src
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)(\.|_)/, '.$2')
      .replace(/\.([^.]+)$/, '_' + sz + '.$1');
  }

  /* ── Global store ── */
  var bundlePickers = [];

  /* ── Init on DOM ready ── */
  document.addEventListener('DOMContentLoaded', function(){
    var bpBlocks = document.querySelectorAll('[data-bp]');
    if(!bpBlocks.length) return;

    /* Shared modal elements */
    var mBackdrop = document.querySelector('[data-bp-modal-backdrop]');
    var modal = document.querySelector('[data-bp-modal]');
    if(!modal || !mBackdrop) return;

    var mClose = modal.querySelector('[data-bp-modal-close]');
    var mSearch = modal.querySelector('[data-bp-modal-search]');
    var mGrid = modal.querySelector('[data-bp-modal-grid]');
    var mCount = modal.querySelector('[data-bp-modal-count]');
    var mConfirm = modal.querySelector('[data-bp-modal-confirm]');
    var mTitle = modal.querySelector('[data-bp-modal-title]');
    var mPagination = modal.querySelector('[data-bp-modal-pagination]');
    var mPagePrev = modal.querySelector('[data-bp-page-prev]');
    var mPageNext = modal.querySelector('[data-bp-page-next]');
    var mPageInfo = modal.querySelector('[data-bp-page-info]');
    var mTabs = modal.querySelector('[data-bp-modal-tabs]');
    var tabBtns = mTabs ? mTabs.querySelectorAll('[data-bp-tab]') : [];

    /* Shared variant sub-modal */
    var vBackdrop = document.querySelector('[data-bp-var-backdrop]');
    var vModal = document.querySelector('[data-bp-var-modal]');
    var vClose = vModal.querySelector('[data-bp-var-close]');
    var vImg = vModal.querySelector('[data-bp-var-img]');
    var vTitle = vModal.querySelector('[data-bp-var-title]');
    var vPrice = vModal.querySelector('[data-bp-var-price]');
    var vOptions = vModal.querySelector('[data-bp-var-options]');
    var vAdd = vModal.querySelector('[data-bp-var-add]');
    var vSoldoutMsg = vModal.querySelector('[data-bp-var-soldout-msg]');

    var activePicker = null;
    var allProducts = [];
    var tempSelections = [];
    var variantProduct = null;
    var variantSelOpts = {};
    var bpPage = 0;
    var bpPerPage = 12;

    /* ── Init each bundle picker block ── */
    bpBlocks.forEach(function(bpEl){
      var handle = bpEl.dataset.bpCollection;
      var maxP = parseInt(bpEl.dataset.bpMax) || 3;
      var blockId = bpEl.dataset.bpBlockId;

      var collections = [{handle: handle, label: bpEl.dataset.bpCollectionLabel || 'Collection 1', cache: null}];
      var h2 = bpEl.dataset.bpCollection2;
      var h3 = bpEl.dataset.bpCollection3;
      if(h2) collections.push({handle: h2, label: bpEl.dataset.bpCollection2Label || 'Collection 2', cache: null});
      if(h3) collections.push({handle: h3, label: bpEl.dataset.bpCollection3Label || 'Collection 3', cache: null});

      var isGated = bpEl.dataset.bpGated === 'true';

      /* Masquage conditionnel : collections qui, selectionnees dans un AUTRE
         bundle picker de la page, masquent ce bloc-ci */
      var wrapperEl = bpEl.closest('[data-bp-wrapper]') || bpEl.parentElement;
      var hideIfHandles = ((wrapperEl && wrapperEl.dataset.bpHideIf) || '')
        .split(',')
        .map(function(h){ return h.trim(); })
        .filter(function(h){ return h.length > 0; });

      var picker = {
        el: bpEl,
        wrapper: wrapperEl,
        hideIf: hideIfHandles,
        conditionHidden: false,
        handle: handle,
        collections: collections,
        activeTab: 0,
        max: maxP,
        blockId: blockId,
        required: bpEl.dataset.bpRequired === 'true',
        noteLabel: bpEl.dataset.bpNoteLabel || '',
        noteValue: bpEl.dataset.bpNoteValue || '',
        reorder: bpEl.dataset.bpReorder === 'true',
        trustOrder: bpEl.dataset.bpTrustOrder === 'true',
        trustLabel: bpEl.dataset.bpTrustLabel || "Je vous fais confiance pour l'ordre",
        trustChecked: false,
        slotLabel: bpEl.dataset.bpSlotLabel || 'Produit',
        gated: isGated,
        active: !isGated, /* active by default unless gated */
        items: []
      };
      bundlePickers.push(picker);

      /* Activation checkbox (gated mode) */
      if(isGated){
        var activateLabel = bpEl.previousElementSibling;
        while(activateLabel && !activateLabel.hasAttribute('data-bp-activate')){
          activateLabel = activateLabel.previousElementSibling;
        }
        if(activateLabel){
          var activateCheck = activateLabel.querySelector('[data-bp-activate-check]');
          /* Propagate accent color to the activation checkbox */
          var accentFromBlock = bpEl.style.getPropertyValue('--bp-accent') || '#1a1a1a';
          activateLabel.style.setProperty('--bp-accent', accentFromBlock);

          if(activateCheck){
            activateCheck.addEventListener('change', function(){
              picker.active = activateCheck.checked;
              if(activateCheck.checked){
                /* Show bundle with animation */
                bpEl.style.display = '';
                bpEl.style.maxHeight = '0';
                bpEl.style.opacity = '0';
                bpEl.offsetHeight; /* force reflow */
                bpEl.classList.add('is-active');
                bpEl.style.maxHeight = bpEl.scrollHeight + 'px';
                bpEl.style.opacity = '1';
                setTimeout(function(){ bpEl.style.maxHeight = ''; }, 450);
              } else {
                /* Hide bundle with animation & clear selections */
                bpEl.style.maxHeight = bpEl.scrollHeight + 'px';
                bpEl.offsetHeight;
                bpEl.style.maxHeight = '0';
                bpEl.style.opacity = '0';
                bpEl.classList.remove('is-active');
                setTimeout(function(){
                  bpEl.style.display = 'none';
                  bpEl.style.maxHeight = '';
                  bpEl.style.opacity = '';
                }, 450);
                /* Clear all selected items */
                picker.items = [];
                renderSlots(picker);
              }
              evaluateConditions();
            });
          }
        }
      }

      /* Click slot cards to open modal */
      bpEl.querySelectorAll('[data-bp-slot-card]').forEach(function(card){
        card.addEventListener('click', function(e){
          if(e.target.closest('[data-bp-slot-remove]')) return;
          if(card.classList.contains('has-product')) return;
          openModal(picker);
        });
      });

      /* Collapsible toggle */
      var bpToggle = bpEl.querySelector('[data-bp-toggle]');
      var bpBody = bpEl.querySelector('[data-bp-body]');
      if(bpToggle && bpBody){
        bpToggle.addEventListener('click', function(){
          var wasCollapsed = bpBody.classList.contains('is-collapsed');
          if(wasCollapsed){
            bpBody.classList.remove('is-collapsed');
            bpBody.style.maxHeight = bpBody.scrollHeight + 'px';
            bpToggle.setAttribute('aria-expanded', 'true');
            setTimeout(function(){ bpBody.style.maxHeight = ''; }, 400);
          } else {
            bpBody.style.maxHeight = bpBody.scrollHeight + 'px';
            bpBody.offsetHeight; /* force reflow */
            bpBody.style.maxHeight = '0';
            bpBody.classList.add('is-collapsed');
            bpToggle.setAttribute('aria-expanded', 'false');
            setTimeout(function(){ bpBody.style.maxHeight = ''; }, 400);
          }
        });
        if(bpBody.classList.contains('is-collapsed')){
          bpBody.style.maxHeight = '0';
        }
      }

      /* Trust order checkbox */
      if(picker.reorder && picker.trustOrder){
        var trustCheck = bpEl.querySelector('[data-bp-trust-check]');
        if(trustCheck){
          trustCheck.addEventListener('change', function(){
            picker.trustChecked = trustCheck.checked;
            renderSlots(picker);
          });
        }
      }

      renderSlots(picker);
    });

    evaluateConditions();

    /* ═══ MASQUAGE CONDITIONNEL ═══
       Un bloc peut declarer des collections « declencheuses ». Des qu'un AUTRE
       bundle picker de la page contient un produit issu d'une de ces collections,
       le bloc est masque, ses selections sont effacees et il n'est plus requis. */

    function cacheHasProduct(cache, productId){
      if(!cache) return false;
      for(var i = 0; i < cache.length; i++){
        if(String(cache[i].id) === String(productId)) return true;
      }
      return false;
    }

    /* Collection d'origine d'un produit choisi : onglet actif en priorite,
       sinon premiere collection du picker qui contient ce produit (cas recherche globale). */
    function productCollectionHandle(picker, productId){
      var active = picker.collections[picker.activeTab];
      if(active && cacheHasProduct(active.cache, productId)) return active.handle;
      for(var i = 0; i < picker.collections.length; i++){
        var col = picker.collections[i];
        if(cacheHasProduct(col.cache, productId)) return col.handle;
      }
      return active ? active.handle : '';
    }

    /* Retourne true si l'etat du bloc a change */
    function setConditionHidden(picker, hidden){
      if(picker.conditionHidden === hidden) return false;
      picker.conditionHidden = hidden;
      var wrap = picker.wrapper;
      if(!wrap) return true;

      if(hidden){
        /* Efface les selections pour qu'elles ne partent pas au panier */
        picker.items = [];
        renderSlots(picker);
        wrap.classList.add('is-animating');
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
        wrap.offsetHeight; /* force reflow */
        wrap.style.maxHeight = '0';
        wrap.style.opacity = '0';
        setTimeout(function(){
          if(!picker.conditionHidden) return;
          wrap.classList.add('is-condition-hidden');
          wrap.classList.remove('is-animating');
          wrap.style.maxHeight = '';
          wrap.style.opacity = '';
        }, 400);
        return true;
      } else {
        wrap.classList.remove('is-condition-hidden');
        wrap.classList.add('is-animating');
        wrap.style.maxHeight = '0';
        wrap.style.opacity = '0';
        wrap.offsetHeight; /* force reflow */
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
        wrap.style.opacity = '1';
        setTimeout(function(){
          if(picker.conditionHidden) return;
          wrap.classList.remove('is-animating');
          wrap.style.maxHeight = '';
          wrap.style.opacity = '';
        }, 400);
        return true;
      }
    }

    /* Masquer un bloc vide ses selections, ce qui peut a son tour liberer un
       autre bloc : on repasse jusqu'a stabilisation (3 passes max par securite). */
    function evaluateConditions(){
      for(var pass = 0; pass < 3; pass++){
        var changed = false;
        bundlePickers.forEach(function(pk){
          if(!pk.hideIf.length) return;
          var shouldHide = bundlePickers.some(function(other){
            if(other === pk) return false;
            if(other.gated && !other.active) return false;
            if(other.conditionHidden) return false;
            return other.items.some(function(it){
              return it.collection && pk.hideIf.indexOf(it.collection) >= 0;
            });
          });
          if(setConditionHidden(pk, shouldHide)) changed = true;
        });
        if(!changed) break;
      }
    }

    /* ═══ RENDER SLOTS ═══ */
    function renderSlots(picker){
      var slots = picker.el.querySelectorAll('[data-bp-slot]');
      var slotsContainer = picker.el.querySelector('.cds-pp__bp-slots');
      var reorderActive = picker.reorder && !picker.trustChecked;

      if(slotsContainer){
        if(reorderActive) slotsContainer.classList.add('bp-reorder-enabled');
        else slotsContainer.classList.remove('bp-reorder-enabled');
      }

      slots.forEach(function(slot, i){
        var card = slot.querySelector('[data-bp-slot-card]');
        var label = slot.querySelector('.cds-pp__bp-slot-label');
        var item = picker.items[i] || null;

        var oldPrice = slot.querySelector('.cds-pp__bp-slot-price');
        if(oldPrice) oldPrice.remove();
        var oldQty = slot.querySelector('.cds-pp__bp-slot-qty');
        if(oldQty) oldQty.remove();

        slot.classList.remove('bp-dragging', 'bp-drag-over');
        slot.removeAttribute('draggable');

        if(item){
          card.classList.add('has-product');
          var orderBadge = reorderActive ? '<span class="cds-pp__bp-slot-order">' + (i+1) + '</span>' : '';
          var arrowsHtml = '';
          if(reorderActive && picker.items.length > 1){
            var lDis = i === 0 ? ' disabled' : '';
            var rDis = i === picker.items.length - 1 ? ' disabled' : '';
            arrowsHtml = '<div class="cds-pp__bp-slot-arrows">'
              + '<button type="button" class="cds-pp__bp-slot-arrow" data-bp-arrow="left" data-bp-arrow-idx="' + i + '"' + lDis + '><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>'
              + '<button type="button" class="cds-pp__bp-slot-arrow" data-bp-arrow="right" data-bp-arrow-idx="' + i + '"' + rDis + '><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg></button>'
              + '</div>';
          }
          card.innerHTML = orderBadge + '<img class="cds-pp__bp-slot-img" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' + arrowsHtml + '<button type="button" class="cds-pp__bp-slot-remove" data-bp-slot-remove data-bp-slot-idx="' + i + '"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
          label.textContent = item.title;
          label.classList.add('has-product');

          /* Prix a 0 (produit offert) : on n'affiche rien */
          if(!isFreePrice(item.price * item.quantity)){
            var priceEl = document.createElement('div');
            priceEl.className = 'cds-pp__bp-slot-price';
            priceEl.textContent = fmt(item.price * item.quantity);
            slot.appendChild(priceEl);
          }

          if(item.quantity > 1){
            var qtyEl = document.createElement('div');
            qtyEl.className = 'cds-pp__bp-slot-qty';
            qtyEl.textContent = 'x' + item.quantity;
            slot.appendChild(qtyEl);
          }

          if(reorderActive) slot.setAttribute('draggable', 'true');

          card.querySelector('[data-bp-slot-remove]').addEventListener('click', function(e){
            e.stopPropagation();
            picker.items.splice(i, 1);
            renderSlots(picker);
            evaluateConditions();
          });

          /* Arrow reorder buttons */
          if(reorderActive){
            card.querySelectorAll('[data-bp-arrow]').forEach(function(arrow){
              arrow.addEventListener('click', function(ae){
                ae.stopPropagation();
                ae.preventDefault();
                var dir = arrow.dataset.bpArrow;
                var idx = parseInt(arrow.dataset.bpArrowIdx);
                if(dir === 'left') swapItems(picker, idx, idx - 1);
                else swapItems(picker, idx, idx + 1);
              });
            });
          }
        } else {
          card.classList.remove('has-product');
          card.innerHTML = '<div class="cds-pp__bp-slot-plus"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></div>';
          label.textContent = picker.slotLabel + ' ' + (i + 1);
          label.classList.remove('has-product');
        }
      });

      /* Trust checkbox visibility */
      var trustEl = picker.el.querySelector('[data-bp-trust]');
      if(trustEl) trustEl.style.display = picker.items.length > 0 ? '' : 'none';

      /* Reorder hint visibility */
      var reorderHints = picker.el.querySelectorAll('.cds-pp__bp-reorder-hint');
      reorderHints.forEach(function(hint){
        hint.style.display = (picker.reorder && !picker.trustChecked) ? '' : 'none';
      });

      /* Counter */
      var counter = picker.el.querySelector('[data-bp-counter]');
      var cText = picker.el.querySelector('[data-bp-counter-text]');
      var cFill = picker.el.querySelector('[data-bp-counter-fill]');
      var hCounter = picker.el.querySelector('[data-bp-header-counter]');
      var hcText = picker.el.querySelector('[data-bp-header-counter-text]');
      var hcFill = picker.el.querySelector('[data-bp-header-counter-fill]');
      if(counter) counter.style.display = '';
      if(cText) cText.textContent = picker.items.length + '/' + picker.max;
      if(cFill) cFill.style.width = (picker.items.length / picker.max * 100) + '%';
      if(hCounter){ hCounter.style.display = ''; }
      if(hcText) hcText.textContent = picker.items.length + '/' + picker.max;
      if(hcFill) hcFill.style.width = (picker.items.length / picker.max * 100) + '%';

      /* Subtotal */
      var subEl = picker.el.querySelector('[data-bp-subtotal]');
      if(subEl){
        var sub = 0;
        picker.items.forEach(function(it){ sub += it.price * it.quantity; });
        /* Sous-total masque si aucun produit ou si le total est a 0 (produits offerts) */
        if(picker.items.length > 0 && !isFreePrice(sub)){
          subEl.textContent = 'Sous-total : ' + fmt(sub);
          subEl.classList.add('is-visible');
        } else {
          subEl.textContent = '';
          subEl.classList.remove('is-visible');
        }
      }

      /* Bind drag & drop */
      if(picker.reorder && !picker.trustChecked) bindDragDrop(picker);
    }

    /* ═══ DRAG & DROP ═══ */
    var bpDrag = { active: false, fromIdx: -1, picker: null };

    function getSlotIdx(slotEl){
      return Array.prototype.indexOf.call(slotEl.parentElement.children, slotEl);
    }

    function swapItems(picker, fromIdx, toIdx){
      if(fromIdx === toIdx || fromIdx < 0 || fromIdx >= picker.items.length || toIdx < 0 || toIdx >= picker.items.length) return;
      var moved = picker.items.splice(fromIdx, 1)[0];
      picker.items.splice(toIdx, 0, moved);
      renderSlots(picker);
    }

    function dragCleanup(){
      document.querySelectorAll('.bp-dragging,.bp-drag-over').forEach(function(el){ el.classList.remove('bp-dragging','bp-drag-over'); });
      bpDrag.active = false;
      bpDrag.fromIdx = -1;
      bpDrag.picker = null;
    }

    function bindDragDrop(picker){
      var slots = picker.el.querySelectorAll('[data-bp-slot]');
      slots.forEach(function(slot, i){
        if(!picker.items[i]) return;
        slot.addEventListener('dragstart', function(e){
          if(!picker.items[i]) return;
          dragCleanup();
          bpDrag.fromIdx = i;
          bpDrag.picker = picker;
          bpDrag.active = true;
          slot.classList.add('bp-dragging');
          e.dataTransfer.effectAllowed = 'move';
          e.dataTransfer.setData('text/plain', String(i));
        });
        slot.addEventListener('dragover', function(e){
          e.preventDefault();
          e.dataTransfer.dropEffect = 'move';
          if(!bpDrag.active || bpDrag.picker !== picker) return;
          var idx = getSlotIdx(slot);
          if(idx < picker.items.length && idx !== bpDrag.fromIdx) slot.classList.add('bp-drag-over');
        });
        slot.addEventListener('dragleave', function(){ slot.classList.remove('bp-drag-over'); });
        slot.addEventListener('drop', function(e){
          e.preventDefault();
          if(!bpDrag.active || bpDrag.picker !== picker) return;
          var toIdx = getSlotIdx(slot);
          var from = bpDrag.fromIdx;
          dragCleanup();
          swapItems(picker, from, toIdx);
        });
        slot.addEventListener('dragend', function(){ dragCleanup(); });
      });
    }

    /* ═══ MODAL ═══ */
    function openModal(picker){
      activePicker = picker;
      tempSelections = picker.items.map(function(it){ return Object.assign({}, it); });
      mSearch.value = '';
      bpPage = 0;

      var blockTitle = picker.el.querySelector('.cds-pp__bp-title');
      mTitle.textContent = (blockTitle ? blockTitle.textContent : '') || 'Choisissez vos produits';

      /* Propagate accent colors */
      var accentColor = getComputedStyle(picker.el).getPropertyValue('--bp-accent').trim() || '#1a1a1a';
      var accentText = getComputedStyle(picker.el).getPropertyValue('--bp-accent-text').trim() || '#fff';
      modal.style.setProperty('--bp-accent', accentColor);
      modal.style.setProperty('--bp-accent-text', accentText);
      vModal.style.setProperty('--bp-accent', accentColor);
      vModal.style.setProperty('--bp-accent-text', accentText);

      /* Tabs */
      if(picker.collections.length > 1 && mTabs){
        mTabs.style.display = '';
        tabBtns.forEach(function(t, i){
          if(i < picker.collections.length){
            t.style.display = '';
            t.textContent = picker.collections[i].label;
            t.classList.toggle('is-active', i === 0);
            t.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          } else {
            t.style.display = 'none';
          }
        });
      } else if(mTabs){
        mTabs.style.display = 'none';
      }
      picker.activeTab = 0;

      mBackdrop.classList.add('is-open');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      loadProducts(picker);
      updateModalFooter();
    }

    function closeModal(){
      mBackdrop.classList.remove('is-open');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      activePicker = null;
    }

    function loadProducts(picker){
      var col = picker.collections[picker.activeTab];
      if(col.cache){
        allProducts = col.cache;
        renderGrid(allProducts);
        return;
      }
      var skeletonHtml = '';
      for(var sk = 0; sk < 6; sk++) skeletonHtml += '<div class="cds-bp-modal__skeleton"></div>';
      mGrid.innerHTML = skeletonHtml;
      if(mPagination) mPagination.style.display = 'none';

      fetch('/collections/' + col.handle + '/products.json?limit=250')
        .then(function(r){ return r.json(); })
        .then(function(data){
          allProducts = data.products || [];
          col.cache = allProducts;
          renderGrid(allProducts);
        })
        .catch(function(){
          mGrid.innerHTML = '<div class="cds-bp-modal__empty">Impossible de charger les produits</div>';
        });
    }

    function loadAllProducts(picker, callback){
      var cols = picker.collections;
      var pending = 0;
      cols.forEach(function(col){ if(!col.cache) pending++; });
      if(pending === 0){ callback(mergeAllCached(cols)); return; }

      var skeletonHtml = '';
      for(var sk = 0; sk < 6; sk++) skeletonHtml += '<div class="cds-bp-modal__skeleton"></div>';
      mGrid.innerHTML = skeletonHtml;
      if(mPagination) mPagination.style.display = 'none';

      cols.forEach(function(col){
        if(col.cache){ checkDone(); return; }
        fetch('/collections/' + col.handle + '/products.json?limit=250')
          .then(function(r){ return r.json(); })
          .then(function(data){ col.cache = data.products || []; })
          .catch(function(){ col.cache = []; })
          .then(checkDone);
      });

      function checkDone(){ pending--; if(pending <= 0) callback(mergeAllCached(cols)); }
    }

    function mergeAllCached(cols){
      var seen = {};
      var merged = [];
      cols.forEach(function(col){
        (col.cache || []).forEach(function(p){
          if(!seen[p.id]){ seen[p.id] = true; merged.push(p); }
        });
      });
      return merged;
    }

    /* ═══ RENDER GRID ═══ */
    function renderGrid(products){
      var q = mSearch.value.toLowerCase().trim();
      var filtered = products;
      if(q) filtered = products.filter(function(p){ return p.title.toLowerCase().indexOf(q) >= 0; });

      if(!filtered.length){
        mGrid.innerHTML = '<div class="cds-bp-modal__empty">Aucun produit trouvé</div>';
        if(mPagination) mPagination.style.display = 'none';
        return;
      }

      var totalPages = Math.ceil(filtered.length / bpPerPage);
      if(bpPage >= totalPages) bpPage = totalPages - 1;
      if(bpPage < 0) bpPage = 0;
      var start = bpPage * bpPerPage;
      var pageProducts = filtered.slice(start, start + bpPerPage);

      if(mPagination){
        if(totalPages > 1){
          mPagination.style.display = '';
          mPageInfo.textContent = (bpPage + 1) + ' / ' + totalPages;
          mPagePrev.disabled = bpPage <= 0;
          mPageNext.disabled = bpPage >= totalPages - 1;
        } else {
          mPagination.style.display = 'none';
        }
      }

      var html = '';
      var noImgSrc = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect width='400' height='400' fill='%23f0f0f0'/%3E%3Csvg x='140' y='140' width='120' height='120' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='1.5'%3E%3Crect x='3' y='3' width='18' height='18' rx='2'/%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'/%3E%3Cpath d='m21 15-5-5L5 21'/%3E%3C/svg%3E%3C/svg%3E";

      pageProducts.forEach(function(p){
        var firstV = p.variants[0];
        var available = p.variants.some(function(v){ return v.available || !v.inventory_management || v.inventory_policy === 'continue'; });
        var hasVariants = p.variants.length > 1;
        var img = p.images && p.images.length ? p.images[0].src.replace(/\.([^.]+)$/, '_400x.$1') : '';
        var selectedCount = tempSelections.filter(function(it){ return String(it.productId) === String(p.id); }).length;
        var isSelected = selectedCount > 0;
        var comparePrice = firstV.compare_at_price && firstV.compare_at_price > firstV.price ? firstV.compare_at_price : 0;
        var savePct = comparePrice ? Math.round((comparePrice - firstV.price) / comparePrice * 100) : 0;
        var hidePrice = isFreePrice(firstV.price * 100);

        html += '<div class="cds-bp-modal__card' + (isSelected ? ' is-selected' : '') + (available ? '' : ' is-soldout') + '" data-bp-card data-bp-pid="' + p.id + '" data-bp-json=\'' + JSON.stringify(p).replace(/'/g, "&#39;") + '\' data-bp-has-variants="' + (hasVariants ? '1' : '0') + '">';
        if(selectedCount > 1) html += '<span class="cds-bp-modal__card-count">&times;' + selectedCount + '</span>';
        if(savePct && !hidePrice) html += '<span class="cds-bp-modal__card-badge">-' + savePct + '%</span>';
        if(!available) html += '<span class="cds-bp-modal__card-badge cds-bp-modal__card-badge--soldout">Épuisé</span>';
        html += '<div class="cds-bp-modal__card-check"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>';

        var imgSrc = img || noImgSrc;
        var fullImgSrc = p.images && p.images.length ? p.images[0].src : '';
        html += '<div class="cds-bp-modal__card-img-wrap">';
        html += '<img class="cds-bp-modal__card-img" src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" onerror="this.onerror=null;this.src=\'' + noImgSrc + '\';">';
        if(fullImgSrc) html += '<button class="cds-bp-modal__card-zoom" data-bp-zoom="' + escapeHtml(fullImgSrc) + '" type="button" aria-label="Agrandir l\'image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></button>';
        html += '</div>';
        html += '<div class="cds-bp-modal__card-body">';
        html += '<h4 class="cds-bp-modal__card-title">' + escapeHtml(p.title) + '</h4>';
        /* Prix a 0 (produit offert) : on n'affiche aucun prix */
        if(!hidePrice){
          html += '<div>';
          if(comparePrice) html += '<span class="cds-bp-modal__card-price--compare">' + fmt(comparePrice * 100) + '</span>';
          html += '<span class="cds-bp-modal__card-price">' + fmt(firstV.price * 100) + '</span>';
          html += '</div>';
        }
        if(hasVariants) html += '<div class="cds-bp-modal__card-variants">' + p.variants.length + ' variantes</div>';
        html += '</div></div>';
      });

      mGrid.innerHTML = html;
      bindCardClicks();
    }

    function bindCardClicks(){
      mGrid.querySelectorAll('[data-bp-card]').forEach(function(card){
        card.addEventListener('click', function(){
          if(tempSelections.length >= activePicker.max) return;
          var pData = JSON.parse(card.dataset.bpJson);
          openVariantModal(pData, card);
        });
      });
      /* Zoom handlers — open gallery with all product images */
      mGrid.querySelectorAll('[data-bp-zoom]').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          e.preventDefault();
          var card = btn.closest('[data-bp-card]');
          var alt = card ? card.querySelector('.cds-bp-modal__card-title').textContent : '';
          /* Get all images from product data */
          var pData = null;
          try { pData = JSON.parse(card.dataset.bpJson); } catch(ex){}
          var images = [];
          if(pData && pData.images && pData.images.length){
            pData.images.forEach(function(img){ images.push(img.src); });
          } else {
            images.push(btn.dataset.bpZoom);
          }
          openZoomGallery(images, 0, alt);
        });
      });
    }

    function updateModalFooter(){
      var count = tempSelections.length;
      var max = activePicker ? activePicker.max : 0;
      mCount.textContent = count + '/' + max + ' sélectionné' + (count > 1 ? 's' : '');
    }

    /* ═══ VARIANT SUB-MODAL ═══ */
    function openVariantModal(pData, card){
      variantProduct = pData;
      variantSelOpts = {};
      vTitle.textContent = pData.title;
      var img = pData.images && pData.images.length ? pData.images[0].src.replace(/\.([^.]+)$/, '_500x.$1') : '';
      vImg.src = img;

      var descEl = vModal.querySelector('[data-bp-var-desc]');
      if(descEl) descEl.innerHTML = (pData.body_html || '').replace(/<img[^>]*>/gi, '');

      function bpHasAvailableForOpt(variants, optIdx, val, otherSel){
        for(var i = 0; i < variants.length; i++){
          var v = variants[i];
          if(!v.available && v.inventory_management && v.inventory_policy !== 'continue') continue;
          if(v['option' + (optIdx + 1)] !== val) continue;
          var ok = true;
          for(var k in otherSel){
            if(parseInt(k) === optIdx) continue;
            if(v['option' + (parseInt(k) + 1)] !== otherSel[k]){ ok = false; break; }
          }
          if(ok) return true;
        }
        return false;
      }

      function updateVarSoldoutStates(){
        vOptions.querySelectorAll('[data-bp-opt-idx]').forEach(function(b){
          var oi = parseInt(b.dataset.bpOptIdx);
          var ov = b.dataset.bpOptVal;
          var avail = bpHasAvailableForOpt(pData.variants, oi, ov, variantSelOpts);
          b.classList.toggle('is-soldout', !avail);
        });
      }

      /* Build options */
      var optsHtml = '';
      (pData.options || []).forEach(function(opt, idx){
        var isColor = isColorOpt(opt.name || opt);
        var optName = opt.name || opt;
        var optVals = [];
        pData.variants.forEach(function(v){
          var val = v['option' + (idx + 1)];
          if(val && optVals.indexOf(val) === -1) optVals.push(val);
        });
        optsHtml += '<div class="cds-bp-variant__group"><div class="cds-bp-variant__label">' + escapeHtml(optName) + ' : <span data-bp-label-idx="' + idx + '"></span></div><div class="cds-bp-variant__options">';
        optVals.forEach(function(val){
          var isAvail = bpHasAvailableForOpt(pData.variants, idx, val, {});
          var soldoutCls = isAvail ? '' : ' is-soldout';
          if(isColor){
            var hex = colorHex(val);
            var cImg = '';
            for(var vi = 0; vi < pData.variants.length; vi++){
              var vr = pData.variants[vi];
              if(vr['option' + (idx + 1)] === val && vr.featured_image){
                cImg = sizedImg(vr.featured_image.src, '80x'); break;
              }
            }
            optsHtml += '<button type="button" class="cds-bp-variant__swatch-color' + soldoutCls + '" data-bp-opt-idx="' + idx + '" data-bp-opt-val="' + escapeHtml(val) + '" title="' + escapeHtml(val) + (isAvail ? '' : ' (Épuisé)') + '">';
            if(cImg) optsHtml += '<img src="' + cImg + '" alt="' + escapeHtml(val) + '">';
            else if(hex) optsHtml += '<span style="background:' + hex + '"></span>';
            else optsHtml += '<span style="background:linear-gradient(135deg,#ddd,#999)"></span>';
            optsHtml += '</button>';
          } else {
            optsHtml += '<button type="button" class="cds-bp-variant__swatch-pill' + soldoutCls + '" data-bp-opt-idx="' + idx + '" data-bp-opt-val="' + escapeHtml(val) + '">' + escapeHtml(val) + (isAvail ? '' : ' (Épuisé)') + '</button>';
          }
        });
        optsHtml += '</div></div>';
      });
      vOptions.innerHTML = optsHtml;

      /* Initial price */
      var fv = pData.variants.find(function(v){ return v.available || !v.inventory_management || v.inventory_policy === 'continue'; }) || pData.variants[0];
      updateVarPrice(fv.price * 100, fv.compare_at_price ? fv.compare_at_price * 100 : 0);

      vAdd.disabled = true;
      vSoldoutMsg.classList.remove('is-visible');
      vAdd.textContent = 'Ajouter au bijou';

      /* Single-variant */
      var singleVar = pData.variants.length === 1;
      if(singleVar){
        vOptions.innerHTML = '';
        var sv = pData.variants[0];
        var svAvail = sv.available || !sv.inventory_management || sv.inventory_policy === 'continue';
        vAdd.disabled = !svAvail;
        if(!svAvail){ vSoldoutMsg.classList.add('is-visible'); vAdd.textContent = 'Épuisé'; }
        (pData.options || []).forEach(function(opt, idx){ variantSelOpts[idx] = sv['option' + (idx + 1)]; });
      }

      /* Bind option clicks */
      vOptions.querySelectorAll('[data-bp-opt-idx]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var idx = parseInt(btn.dataset.bpOptIdx);
          var val = btn.dataset.bpOptVal;
          variantSelOpts[idx] = val;

          var labelSpan = btn.closest('.cds-bp-variant__group').querySelector('[data-bp-label-idx="' + idx + '"]');
          if(labelSpan) labelSpan.textContent = val;

          btn.closest('.cds-bp-variant__options').querySelectorAll('[data-bp-opt-idx]').forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          updateVarSoldoutStates();

          var match = findVarPartial(pData, variantSelOpts);
          if(match && match.featured_image) vImg.src = sizedImg(match.featured_image.src, '500x');

          var exact = findVarExact(pData, variantSelOpts);
          if(exact) updateVarPrice(exact.price * 100, exact.compare_at_price ? exact.compare_at_price * 100 : 0);

          var allSel = Object.keys(variantSelOpts).length >= (pData.options || []).length;
          var exactVar = allSel ? findVarExact(pData, variantSelOpts) : null;
          var isAvailable = exactVar && (exactVar.available || !exactVar.inventory_management || exactVar.inventory_policy === 'continue');
          vAdd.disabled = !isAvailable;

          if(allSel && exactVar && !isAvailable){
            vSoldoutMsg.classList.add('is-visible');
            vAdd.textContent = 'Épuisé';
          } else {
            vSoldoutMsg.classList.remove('is-visible');
            vAdd.textContent = 'Ajouter au bijou';
          }
        });
      });

      /* Already-selected list */
      var existSelWrap = vModal.querySelector('[data-bp-var-selected]');
      if(!existSelWrap){
        existSelWrap = document.createElement('div');
        existSelWrap.setAttribute('data-bp-var-selected', '');
        vAdd.parentElement.insertBefore(existSelWrap, vAdd);
      }
      var selectedOfProduct = tempSelections.filter(function(it){ return String(it.productId) === String(pData.id); });
      if(selectedOfProduct.length > 0){
        var selHtml = '<div class="cds-bp-variant__selected-list">';
        selHtml += '<div class="cds-bp-variant__selected-title">Déjà sélectionné</div>';
        selectedOfProduct.forEach(function(sel){
          var vName = sel.title.indexOf(' — ') >= 0 ? sel.title.split(' — ').slice(1).join(' — ') : sel.title;
          selHtml += '<div class="cds-bp-variant__selected-item"><span>' + escapeHtml(vName) + '</span><button type="button" class="cds-bp-variant__selected-remove" data-bp-var-remove="' + sel.variantId + '">&times;</button></div>';
        });
        selHtml += '</div>';
        existSelWrap.innerHTML = selHtml;
        existSelWrap.querySelectorAll('[data-bp-var-remove]').forEach(function(btn){
          btn.addEventListener('click', function(){
            var vid = btn.dataset.bpVarRemove;
            for(var i = 0; i < tempSelections.length; i++){
              if(String(tempSelections[i].variantId) === String(vid)){
                tempSelections.splice(i, 1); break;
              }
            }
            updateModalFooter();
            closeVariantModal();
            renderGrid(allProducts);
          });
        });
      } else {
        existSelWrap.innerHTML = '';
      }

      vBackdrop.classList.add('is-open');
      vModal.classList.add('is-open');

      /* Zoom in variant modal — gallery with all product images */
      var vZoomBtn = vModal.querySelector('[data-bp-var-zoom]');
      if(vZoomBtn){
        vZoomBtn.onclick = function(e){
          e.stopPropagation();
          var images = [];
          if(pData.images && pData.images.length){
            pData.images.forEach(function(img){ images.push(img.src); });
          } else {
            images.push(vImg.src.replace(/_\d+x\./, '.'));
          }
          /* Find which image is currently shown to start on it */
          var currentSrc = vImg.src.replace(/_\d+x\./, '.');
          var startIdx = 0;
          for(var si = 0; si < images.length; si++){
            if(images[si].indexOf(currentSrc.split('/').pop().split('?')[0].replace(/_\d+x/, '')) >= 0 ||
               currentSrc.indexOf(images[si].split('/').pop().split('?')[0].replace(/\.\w+$/, '')) >= 0){
              startIdx = si; break;
            }
          }
          openZoomGallery(images, startIdx, pData.title);
        };
      }

      /* Add button */
      var addHandler = function(){
        var exact = findVarExact(pData, variantSelOpts);
        if(!exact || (!exact.available && exact.inventory_management && exact.inventory_policy !== 'continue')) return;
        var img2 = vImg.src || img;
        tempSelections.push({
          variantId: String(exact.id),
          productId: String(pData.id),
          title: pData.title + (exact.title !== 'Default Title' ? ' — ' + exact.title : ''),
          price: exact.price * 100,
          image: img2,
          quantity: 1,
          handle: pData.handle,
          /* Collection d'origine — sert au masquage conditionnel des autres blocs */
          collection: activePicker ? productCollectionHandle(activePicker, pData.id) : ''
        });
        if(card) card.classList.add('is-selected');
        updateModalFooter();
        closeVariantModal();
        renderGrid(allProducts);
        vAdd.removeEventListener('click', addHandler);
      };
      vAdd.addEventListener('click', addHandler);
      vModal._addHandler = addHandler;
    }

    function closeVariantModal(){
      vBackdrop.classList.remove('is-open');
      vModal.classList.remove('is-open');
      if(vModal._addHandler) vAdd.removeEventListener('click', vModal._addHandler);
    }

    function updateVarPrice(price, compare){
      /* Prix a 0 (produit offert) : on n'affiche aucun prix */
      if(isFreePrice(price)){ vPrice.innerHTML = ''; return; }
      var html = '';
      if(compare && compare > price) html += '<span class="cds-bp-variant__price--compare">' + fmt(compare) + '</span> ';
      html += '<span class="cds-bp-variant__price">' + fmt(price) + '</span>';
      vPrice.innerHTML = html;
    }

    function findVarPartial(pData, sel){
      for(var i = 0; i < pData.variants.length; i++){
        var v = pData.variants[i], ok = true;
        for(var idx in sel){ if(v['option' + (parseInt(idx) + 1)] !== sel[idx]){ ok = false; break; } }
        if(ok) return v;
      }
      return null;
    }

    function findVarExact(pData, sel){
      var n = (pData.options || []).length;
      if(Object.keys(sel).length < n) return null;
      for(var i = 0; i < pData.variants.length; i++){
        var v = pData.variants[i], ok = true;
        for(var idx = 0; idx < n; idx++){ if(v['option' + (idx + 1)] !== sel[String(idx)]){ ok = false; break; } }
        if(ok) return v;
      }
      return null;
    }

    /* ═══ SEARCH ═══ */
    var searchTimer;
    mSearch.addEventListener('input', function(){
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function(){
        bpPage = 0;
        var q = mSearch.value.trim();
        if(q && activePicker && activePicker.collections.length > 1){
          tabBtns.forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
          loadAllProducts(activePicker, function(merged){
            allProducts = merged;
            renderGrid(allProducts);
          });
        } else {
          if(activePicker && activePicker.collections.length > 1){
            tabBtns.forEach(function(b, i){ b.classList.toggle('is-active', i === activePicker.activeTab); b.setAttribute('aria-selected', i === activePicker.activeTab ? 'true' : 'false'); });
          }
          if(activePicker) allProducts = activePicker.collections[activePicker.activeTab].cache || [];
          renderGrid(allProducts);
        }
      }, 200);
    });

    /* Pagination */
    if(mPagePrev) mPagePrev.addEventListener('click', function(){
      if(bpPage > 0){ bpPage--; renderGrid(allProducts); mGrid.parentElement.scrollTop = 0; }
    });
    if(mPageNext) mPageNext.addEventListener('click', function(){
      bpPage++; renderGrid(allProducts); mGrid.parentElement.scrollTop = 0;
    });

    /* Tabs */
    tabBtns.forEach(function(t){
      t.addEventListener('click', function(){
        if(!activePicker) return;
        var idx = parseInt(this.dataset.bpTab);
        if(idx === activePicker.activeTab) return;
        activePicker.activeTab = idx;
        tabBtns.forEach(function(b, i){
          b.classList.toggle('is-active', i === idx);
          b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        bpPage = 0;
        mSearch.value = '';
        loadProducts(activePicker);
      });
    });

    /* Close handlers */
    mClose.addEventListener('click', closeModal);
    mBackdrop.addEventListener('click', closeModal);
    vClose.addEventListener('click', closeVariantModal);
    vBackdrop.addEventListener('click', closeVariantModal);

    /* ═══ ZOOM GALLERY LIGHTBOX ═══ */
    var zoomOverlay = document.querySelector('[data-bp-zoom-overlay]');
    var zoomCloseBtn = zoomOverlay ? zoomOverlay.querySelector('[data-bp-zoom-close]') : null;
    var zoomImg = zoomOverlay ? zoomOverlay.querySelector('[data-bp-zoom-img]') : null;
    var zoomPrev = zoomOverlay ? zoomOverlay.querySelector('[data-bp-zoom-prev]') : null;
    var zoomNext = zoomOverlay ? zoomOverlay.querySelector('[data-bp-zoom-next]') : null;
    var zoomCounter = zoomOverlay ? zoomOverlay.querySelector('[data-bp-zoom-counter]') : null;
    var zoomThumbs = zoomOverlay ? zoomOverlay.querySelector('[data-bp-zoom-thumbs]') : null;
    var zoomImages = []; /* array of full-size image URLs */
    var zoomIndex = 0;

    function openZoomGallery(images, startIndex, alt){
      if(!zoomOverlay || !images || !images.length) return;
      zoomImages = images;
      zoomIndex = startIndex || 0;
      updateZoomImage(alt);
      buildZoomThumbs();
      requestAnimationFrame(function(){ zoomOverlay.classList.add('is-active'); });
    }

    function updateZoomImage(alt){
      if(!zoomImg) return;
      zoomImg.style.opacity = '0.3';
      zoomImg.src = zoomImages[zoomIndex];
      zoomImg.alt = alt || '';
      zoomImg.onload = function(){ zoomImg.style.opacity = ''; };
      /* Counter */
      if(zoomCounter){
        if(zoomImages.length > 1){
          zoomCounter.textContent = (zoomIndex + 1) + ' / ' + zoomImages.length;
          zoomCounter.style.display = '';
        } else {
          zoomCounter.style.display = 'none';
        }
      }
      /* Nav arrows visibility */
      if(zoomPrev) zoomPrev.style.display = zoomImages.length > 1 ? '' : 'none';
      if(zoomNext) zoomNext.style.display = zoomImages.length > 1 ? '' : 'none';
      if(zoomPrev) zoomPrev.disabled = zoomIndex <= 0;
      if(zoomNext) zoomNext.disabled = zoomIndex >= zoomImages.length - 1;
      /* Update active thumb */
      if(zoomThumbs){
        var thumbEls = zoomThumbs.querySelectorAll('.cds-bp-zoom-overlay__thumb');
        thumbEls.forEach(function(t, i){ t.classList.toggle('is-active', i === zoomIndex); });
        /* Scroll active thumb into view */
        if(thumbEls[zoomIndex]) thumbEls[zoomIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function buildZoomThumbs(){
      if(!zoomThumbs) return;
      if(zoomImages.length <= 1){ zoomThumbs.style.display = 'none'; return; }
      zoomThumbs.style.display = '';
      var html = '';
      zoomImages.forEach(function(src, i){
        var thumbSrc = src.replace(/\.([^.]+)$/, '_100x.$1');
        html += '<img class="cds-bp-zoom-overlay__thumb' + (i === zoomIndex ? ' is-active' : '') + '" src="' + escapeHtml(thumbSrc) + '" data-bp-zoom-thumb-idx="' + i + '" loading="lazy">';
      });
      zoomThumbs.innerHTML = html;
      zoomThumbs.querySelectorAll('[data-bp-zoom-thumb-idx]').forEach(function(thumb){
        thumb.addEventListener('click', function(e){
          e.stopPropagation();
          zoomIndex = parseInt(thumb.dataset.bpZoomThumbIdx);
          updateZoomImage();
        });
      });
    }

    function closeZoom(){
      if(zoomOverlay) zoomOverlay.classList.remove('is-active');
      zoomImages = [];
      zoomIndex = 0;
    }

    if(zoomCloseBtn) zoomCloseBtn.addEventListener('click', closeZoom);
    if(zoomOverlay) zoomOverlay.addEventListener('click', function(e){ if(e.target === zoomOverlay) closeZoom(); });
    if(zoomPrev) zoomPrev.addEventListener('click', function(e){
      e.stopPropagation();
      if(zoomIndex > 0){ zoomIndex--; updateZoomImage(); }
    });
    if(zoomNext) zoomNext.addEventListener('click', function(e){
      e.stopPropagation();
      if(zoomIndex < zoomImages.length - 1){ zoomIndex++; updateZoomImage(); }
    });
    /* Keyboard nav in zoom */
    document.addEventListener('keydown', function(e){
      if(!zoomOverlay || !zoomOverlay.classList.contains('is-active')) return;
      if(e.key === 'ArrowLeft' && zoomIndex > 0){ zoomIndex--; updateZoomImage(); e.preventDefault(); }
      if(e.key === 'ArrowRight' && zoomIndex < zoomImages.length - 1){ zoomIndex++; updateZoomImage(); e.preventDefault(); }
    });

    /* Confirm */
    mConfirm.addEventListener('click', function(){
      if(!activePicker) return;
      activePicker.items = tempSelections.slice();
      renderSlots(activePicker);
      closeModal();
      evaluateConditions();
    });

    /* ESC key */
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        if(zoomOverlay && zoomOverlay.classList.contains('is-active')){ closeZoom(); return; }
        if(vModal.classList.contains('is-open')){ closeVariantModal(); return; }
        if(modal.classList.contains('is-open')){ closeModal(); return; }
      }
    });

    /* ═══════════════════════════════════════
       CART INTEGRATION — Sealina (Flow) theme
       ═══════════════════════════════════════ */

    /* Expose for cart integration */
    window._cdsBPGetItems = function(){
      var items = [];
      bundlePickers.forEach(function(picker){
        /* Skip gated pickers that are not active */
        if(picker.gated && !picker.active) return;
        /* Skip pickers masques par une condition */
        if(picker.conditionHidden) return;
        picker.items.forEach(function(it, idx){
          var item = { id: parseInt(it.variantId), quantity: it.quantity || 1 };
          if(picker.noteLabel && picker.noteValue){
            item.properties = item.properties || {};
            item.properties[picker.noteLabel] = picker.noteValue;
          }
          if(picker.reorder){
            item.properties = item.properties || {};
            if(picker.trustChecked){
              item.properties['Ordre'] = picker.trustLabel;
            } else {
              item.properties['Ordre'] = String(idx + 1);
            }
          }
          items.push(item);
        });
      });
      return items;
    };

    window._cdsBPValidate = function(){
      for(var i = 0; i < bundlePickers.length; i++){
        var pk = bundlePickers[i];
        /* Skip gated pickers that are not active */
        if(pk.gated && !pk.active) continue;
        /* Skip pickers masques par une condition */
        if(pk.conditionHidden) continue;
        if(pk.required && pk.items.length < pk.max){
          var title = pk.el.querySelector('.cds-pp__bp-title');
          var label = title ? title.textContent.trim() : 'Bundle';

          /* Auto-expand if collapsed */
          var bpToggle = pk.el.querySelector('[data-bp-toggle]');
          var bpBody = pk.el.querySelector('[data-bp-body]');
          if(bpToggle && bpBody && bpBody.classList.contains('is-collapsed')){
            bpBody.classList.remove('is-collapsed');
            bpBody.style.maxHeight = bpBody.scrollHeight + 'px';
            bpToggle.setAttribute('aria-expanded', 'true');
            setTimeout(function(){ bpBody.style.maxHeight = ''; }, 400);
          }

          var errEl = pk.el.querySelector('[data-bp-error]');
          if(errEl){
            errEl.textContent = 'Veuillez sélectionner ' + pk.max + ' produit' + (pk.max > 1 ? 's' : '') + ' pour « ' + label + ' »';
            errEl.classList.add('is-visible');
            setTimeout(function(){ errEl.classList.remove('is-visible'); }, 5000);
          }
          pk.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return 'Veuillez compléter « ' + label + ' » (' + pk.items.length + '/' + pk.max + ')';
        }
        var errEl2 = pk.el.querySelector('[data-bp-error]');
        if(errEl2) errEl2.classList.remove('is-visible');
      }
      return null;
    };

    window._cdsBPReset = function(){
      bundlePickers.forEach(function(pk){
        pk.items = [];
        renderSlots(pk);
      });
      evaluateConditions();
    };

    /* ── Patch Sealina's ProductForm ── */
    function patchProductForm(){
      var productFormEl = document.querySelector('product-form');
      if(!productFormEl) return;

      /* Wait for the element to be fully initialized */
      var waitForForm = function(){
        if(!productFormEl.form || typeof productFormEl.addItemsToCart !== 'function'){
          setTimeout(waitForForm, 100);
          return;
        }

        /* Patch prepareForSubmission to validate bundles first */
        var originalPrepare = productFormEl.prepareForSubmission.bind(productFormEl);
        productFormEl.prepareForSubmission = function(){
          var err = window._cdsBPValidate();
          if(err) return;
          originalPrepare();
        };

        /* Patch addItemsToCart to include bundle items */
        var originalAddItems = productFormEl.addItemsToCart.bind(productFormEl);
        productFormEl.addItemsToCart = async function(){
          var bpItems = window._cdsBPGetItems();

          /* No bundle items → original flow */
          if(!bpItems.length){
            return originalAddItems();
          }

          /* Build combined items payload */
          this.isProcessing = true;
          try {
            var formData = new FormData(this.form);
            var mainItem = {
              id: parseInt(formData.get('id')),
              quantity: parseInt(formData.get('quantity')) || 1
            };

            /* Collect form properties */
            var props = {};
            for(var pair of formData.entries()){
              var key = pair[0], value = pair[1];
              if(key.indexOf('properties[') === 0 && value){
                props[key.slice(11, -1)] = value;
              }
            }
            if(Object.keys(props).length) mainItem.properties = props;

            /* ── Liaison parent / enfants ──
               Un identifiant unique relie le produit principal aux produits issus
               des bundle pickers. Les proprietes prefixees par « _ » sont privees :
               invisibles dans le panier et au checkout, mais lisibles en Liquid.
               Un id different a chaque ajout garantit que deux bundles identiques
               restent deux lignes distinctes. */
            var bundleId = 'bp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
            mainItem.properties = mainItem.properties || {};
            mainItem.properties['_bundle_id'] = bundleId;
            mainItem.properties['_bundle_role'] = 'parent';

            var allItems = [mainItem];
            bpItems.forEach(function(bi){
              bi.properties = bi.properties || {};
              bi.properties['_bundle_id'] = bundleId;
              bi.properties['_bundle_role'] = 'child';
              allItems.push(bi);
            });

            /* Gift wrap */
            if(typeof this.giftWrapEnabled === 'function' && this.giftWrapEnabled()){
              allItems.push({ id: parseInt(this.giftWrapProductId), quantity: mainItem.quantity });
            }

            var payload = { items: allItems };
            if(this.cartType === 'drawer') payload.sections = 'cart-drawer';

            var response = await fetch(window.routes.cart_add_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(payload)
            });

            if(response.ok && this.cartType === 'drawer'){
              try {
                var data = await response.clone().json();
                this.updateCartDrawer(data);
              } catch(e){}
            }

            this.processResponse(response);

            /* Reset bundle pickers after successful add */
            if(response.ok) window._cdsBPReset();

          } catch(error){
            console.error('CDS Bundle Picker — Error adding items to cart:', error);
          } finally {
            this.isProcessing = false;
          }
        };
      };

      waitForForm();
    }

    patchProductForm();

  }); /* end DOMContentLoaded */
})();
